import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorValidation } from '@/store/targetAccumulator/selectors.ts';

const StrikeDown = () => {
  const tileId = useTargetAccumulatorTileId();
  const strikeDown = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.strikeDown);
  const isCustom = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.customFields?.includes('StrikeDown') ?? false,
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleStrikeDown = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Strike Down changed',
      isDefined(value) ? String(value) : 'cleared',
    );

    return checkTargetAccumulatorWithTradeCapture({
      strikeDown: isDefined(value) ? value : null,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.strikeDown">
      <TradeCaptureValidationWrapper validation={validation?.strikeDown}>
        <SgNumberInput
          valuePosition="start"
          allowNegative={false}
          className={isCustom ? 'text-info' : undefined}
          data-e2e-is-modified={isCustom}
          selectAllOnFocus
          value={strikeDown}
          maxDecimals={9}
          onChange={handleStrikeDown}
          size="sm"
          data-e2e="strikeDown"
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default StrikeDown;
